import React, { Component } from 'react';
import {PropTypes} from 'prop-types';
import {ProductBrief} from 'components/partials/product';
import {UserInfo} from 'components/partials/userinfo';
import {Requests} from 'api';
import {ShowIf} from 'components/utils';
import {ConversationContainer, ConversationForm} from 'components/conversations';

class RequestDetail extends Component {
  constructor(propx, context) {
    super(propx, context);

    this.state = {
      id: this.props.id
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.id != this.state.id) {
      this.setState({
        id: nextProps.id
      })
    }
  }

  componentDidMount() {
    Requests.actions.get.request({
      id: this.props.id,
      filter: {
        include: ['user', 'product', 'business', 'conversation']
      }
    }).then(response => {
      this.setState({
        request: response.data
      })
    })
  }

  render() {
    if (!this.state.request) return null;

    return (
      <div>

        <h1 className='user-header'>Thông tin người yêu cầu</h1>
        <section className="list-request">

          <UserInfo user={this.state.request.user}/>
          <div className='list-request-wrap'>
          </div>
        </section>
        <br/>
        <h1 className='user-header'>Thông tin sản phẩm</h1>
        <section className="list-request">

          <ProductBrief product={this.state.request.product}/>
          <div className='list-request-wrap'>
          </div>
        </section>
        <br/>
        <h1 className='user-header'>Thông tin trao đổi</h1>
        {
          this.state.request && this.state.request.conversation &&
          <ConversationContainer
            conversation={this.state.request && this.state.request.conversation}
          />
        }
        <ShowIf condition={
          (this.state.request.product && this.props.type == 'MY_REQUESTS' && this.state.request.conversation )
          || (this.state.request.product && this.props.type == 'MY_BUSINESS_REQUEST')
        }>
          <ConversationForm
            objectId={this.state.request.id}
            conversation={this.state.request.conversation}
          />
        </ShowIf>

      </div>


    );
  }

}

RequestDetail.propTypes = {
  type: PropTypes.oneOf(['MY_REQUESTS', 'MY_BUSINESS_REQUEST'])
}

RequestDetail.defaultProps = {
  type: 'MY_BUSINESS_REQUEST'
}

export default RequestDetail;



// WEBPACK FOOTER //
// ./components/requests/RequestDetail.jsx